export default {
  en: {
    pricing: "Pricing",
    monthly: "Monthly",
    annual: "Annual",
    record: "record",
    signupforfree:"Sign up for free!",
    messages: {
      noAdminPermissions: "You do not have administration permissions for this account",
      contactAdmin: "Please contact the administration account owner for assistance.",
      loading: "Loading...",
      startFree: "Start for free",
      getStartedFree: "Get started for free with our generous plan, perfect for hobbyists and those exploring our services. Enjoy up to 1,000 records per day, including both historical weather data and forecasts for any location worldwide—no cost, no commitment!",
      yourCurrentSubscriptions: "Your current subscriptions",
      freePlan: "Free mode enabled - Upgrade your service plan to enable higher data limits and more features.",
      addPaymentMethod: "Adding a payment method will convert this to the metered plan",
      cancelsOn: "Cancels on",
      renewsOn: "Renews on",
      directBilling: "This subscription is billed directly. Please contact your account representative or sales@visualcrossing.com.",
      contactSupportForScheduled: "Please contact Visual Crossing Support to modify scheduled subscriptions.",
      twoMonthsFree: "2 months free!",
      availablePrimarySubscriptions: "Available primary subscriptions",
      openingPaymentPage: "Opening the payment processing page...",
      scheduledsubcription: "Please contact Visual Crossing Support to modify scheduled subscriptions.",
      scheduledsubcriptions: "Scheduled subscriptions",
      starts: "Starts on ",
      ends: "Ends on ",
      annualviolator:"2 months free!",
      availableprimarysubs: "Available primary subscriptions",
      availableaddonsubs: "Available addon subscriptions",
      current: "Current",
      contactus: "Contact us",
      comingsoon: "Coming soon",
      inpreview: "In preview",
      contactsupport: "Contact support",
      chooseplan: "Choose plan",
      details: "Read more",
      cancel: "Cancel",
      renews: "Renews: ",
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      noprimary: "Add Subscription to Continue",
      cancelling: "Cancelling",
     
    },
    
    descriptions: {
      meteredName: "Metered",
      metered: "The flexible weather data option for apps, teams, and periodic users.",
      corporateName: "Corporate",
      corporate: "For teams and small businesses who need to store and share weather data.",
      professionalName: "Professional",
      professional: "For individual users doing planning, data science, personal projects, and prototyping.",
      enterpriseName: "Enterprise",
      enterprise: "For business applications that demand high-availability and unlimited access.",
      histFcstName: "Historical Forecast",
      histFcst: "Weather forecasts created on historical dates.",
      weatherMaps:"Weather maps API for building interactive weather maps",
      weatherMapsName:"Weather Maps",
      weatherStats:"Detailed climate and weather statistics",
      weatherStatsName:"Weather Statistics",
    },
    marketingFeatures:{
      unlimitedPerMo:"Unlimited records/mo.",
      singleConcurrency:"Single concurrency",
      unlimitedConcurrency:"Unlimited concurrency",
      customConcurrency:"Custom concurrency",
      teamConcurrency:"Team concurrency",
      tenMPerMo:"10,000,000 records/mo.",
    },
    features: {
      history: "50 years history",
      forecast: "15-day forecast",
      conditions: "Current conditions",
      coverage: "Global coverage",
      api: "API & download",
      forum: "Forum support",
      geocoding: "Location geocoding",
      alerts: "Weather Alerts",
      astronomy: "Astronomy data",
      unlimited: "Unlimited records/mo.",
      team: "Team concurrency",
      email: "Email support",
      https: "HTTPS encryption",
      records: "10,000,000 records/mo.",
      concurrency: "Single concurrency",
      bulkschedule:"Bulk & scheduler", 
      bulkonly:"Bulk",
      subhourly:"Sub-hourly data", 
      tenusers:"10 named users", 
      degreedays:"Degree Days API", 
      energyelements:"Energy", 
      agelements:"Agriculture", 
      marine:"Maritime Wave & Swell", 
      noattribution:"No attribution", 
      unlimitedusers:"Unlimited users", 
      sla:"SLA guarantee", 
      invoice:"Custom invoicing", 
      yearsavailable: "6-years' past forecasts",
      fullforecast: "Full 15-day forecast",
      customdays: "Choose forecast days",
      multiplelayers: "Multiple Model Layers",
      radarlayers: "Forecast Radar Layers",
      preciptotals: "Precipitation Totals",
      easyintegrate: "Easy to integrate",
      historysummaries: "Historical Summary",
      routefiltering: "Weather by Route",
      frostdates: "Frost Dates",
      customfiltering: "Threshold Filtering",
      areaagg: "Aggregation by Area",
    },
  },
  de: {
    pricing: "Kosten",
    monthly: "Monatlich",
    annual: "Jährlich",
    month: "Monat",
    year: "Jähr",
    record: "Datensatz",
    signupforfree: "Kostenlos anmelden!",
    messages: {
      noAdminPermissions: "Sie haben keine Administratorrechte für dieses Konto",
      contactAdmin: "Bitte wenden Sie sich an den Administrator, um Unterstützung zu erhalten.",
      loading: "Lädt...",
      startFree: "Kostenlos starten",
      getStartedFree: "Testen Sie unseren kostenlosen Zugang, ideal for Hobby und zum Evaluieren. Sie bekommen täglich 1000 Datensätze, inklusive historischer Daten und Wettervorhersagen weltweit. Keine Kosten, Keine Verpflichtungen! ",
      yourCurrentSubscriptions: "Ihre aktuellen Abonnements",
      freePlan: "Freier Modus aktiviert – Aktualisieren Sie Ihren Serviceplan, um höhere Datenlimits und mehr Funktionen freizuschalten.",
      addPaymentMethod: "Das Hinzufügen einer Zahlungsmethode wird diesen in den nutzungsabhängigen Plan umwandeln",
      cancelsOn: "Endet am",
      renewsOn: "Erneuert am",
      directBilling: "Dieses Abonnement wird direkt abgerechnet. Bitte wenden Sie sich an Ihren Vertriebsontakt oder an sales@visualcrossing.com.",
      contactSupportForScheduled: "Bitte wenden Sie sich an den Visual Crossing Support, um geplante Abonnements zu ändern.",
      twoMonthsFree: "2 Monate kostenlos!",
      availablePrimarySubscriptions: "Verfügbare primäre Abonnements",
      availableaddonsubs: "Verfügbare Zusatzabonnements",
      openingPaymentPage: "Öffnet die Zahlungsabwicklungsseite...",
      scheduledsubcription: "Bitte wenden Sie sich an den Visual Crossing Support, um geplante Abonnements zu ändern.",
      scheduledsubcriptions: "Geplante Abonnements",
      starts: "Beginnt am ",
      ends: "Endet am ",
      annualviolator: "2 Monate kostenlos!",
      availableprimarysubs: "Verfügbare primäre Abonnements",
      current: "Aktuell",
      contactus: "Kontakt",
      comingsoon: "Vorschau",
      inpreview: "In der Vorschau",
      contactsupport: "Support kontaktieren",
      chooseplan: "Plan auswählen",
      details: "Mehr erfahren",
      cancel: "Abbrechen",
      renews: "Erneuert: ",
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      noprimary: "Kein primäres Abonnement",
      cancelling: "Wird gekündigt",
    },
    descriptions: {
      meteredName: "Metered",
      metered: "Die flexible Wetterdatenoption für Apps, Teams und gelegentliche Nutzer.",
      corporateName: "Corporate",
      corporate: "Für Teams und kleine Unternehmen, die Wetterdaten gemeinsam nutzen.",
      professionalName: "Professional",
      professional: "Für Einzelbenutzer in Planung, Datascience, persönlichen Projekten oder Prototypen.",
      enterpriseName: "Enterprise",
      enterprise: "Für Anwendungen, die hohe Verfügbarkeit und unbegrenzten Zugriff erfordern.",
      histFcstName: "Historische Vorhersage",
      histFcst: "Wettervorhersagen, die zu historischen Zeitpunkten erstellt wurden.",
      weatherMaps: "Wetterkarten-API zum Erstellen interaktiver Wetterkarten",
      weatherMapsName: "Wetterkarten",
      weatherStats: "Detaillierte Klima- und Wetterstatistiken",
      weatherStatsName: "Wetterstatistiken",
    },
    marketingFeatures: {
      unlimitedPerMo: "Unbegrenzte Datensätze/Monat",
      singleConcurrency: "Einzelne Gleichzeitigkeit",
      unlimitedConcurrency: "Unbegrenzte Gleichzeitigkeit",
      customConcurrency: "Individuelle Gleichzeitigkeit",
      teamConcurrency: "Team-Gleichzeitigkeit",
      tenMPerMo: "10.000.000 Datensätze/Monat",
    },
    features: {
      history: "50 Jahre Wetterhistorie",
      forecast: "15-Tage-Vorhersage",
      conditions: "Aktuelle Bedingungen",
      coverage: "Globale Abdeckung",
      api: "API & Download",
      forum: "Forum-Support",
      geocoding: "Standort-Geokodierung",
      alerts: "Wetterwarnungen",
      astronomy: "Astronomiedaten",
      unlimited: "Unbegrenzte Datensätze/Monat",
      team: "Team-Gleichzeitigkeit",
      email: "E-Mail-Support",
      https: "HTTPS-Verschlüsselung",
      records: "10.000.000 Datensätze/Monat",
      concurrency: "Einzel-Gleichzeitigkeit",
      bulkschedule: "Bulk & Terminierung",
      bulkonly:"Bulk",
      subhourly: "Minütliche Daten",
      tenusers: "10 individuelle Benutzer",
      degreedays: "Gradtagszahlen-API",
      energyelements: "Energie",
      agelements: "Landwirtschaft",
      marine: "Seegang & Wellenvorhersage",
      noattribution: "Keine Referenzierung",
      unlimitedusers: "Unbegrenzte Benutzer",
      sla: "SLA-Garantie",
      invoice: "Individuelle Rechnungsstellung",
      yearsavailable: "6 Jahre historische Vorhersagen",
      fullforecast: "Vollständige 15-Tage-Vorhersage",
      customdays: "Vorhersagetage anpassen",
      multiplelayers: "Mehrere Modell-Ebenen",
      radarlayers: "Vorhersage-Radarschichten",
      preciptotals: "Niederschlagssummen",
      easyintegrate: "Einfache Integration",
      historysummaries: "Historische Zusammenfassungen",
      routefiltering: "Wetter entlang der Route",
      frostdates: "Frostdaten",
      customfiltering: "Schwellenwert-Filterung",
      areaagg: "Aggregation nach Gebiet",
    },
  },

};
